@if (href) {
  <a [href]="href" [target]="target" [ngClass]="myClass" [attr.aria-disabled]="disabled ? true : null" tabindex="0">
    <p-button [text]="text" [type]="buttonType" [styleClass]="myClass" label="" [disabled]="disabled">
      <fa-icon [icon]="icon"></fa-icon>
    </p-button>
  </a>
} @else {
  @if (routerLink) {
    <p-button [text]="text" [type]="buttonType" [ngClass]="myClass" [styleClass]="myClass" label="" [disabled]="disabled" [routerLink]="routerLink" [attr.aria-disabled]="disabled ? true : null" tabindex="0">
      <fa-icon [icon]="icon"></fa-icon>
    </p-button>
  } @else {
    <p-button [text]="text" [type]="buttonType" [ngClass]="myClass" [styleClass]="myClass" label="" [disabled]="disabled" (click)="onButtonClick($event)">
      <fa-icon [icon]="icon" [animation]="animation()"></fa-icon>
    </p-button>
  }
}
